module.exports = {"Southeast":["AL","AR","FL","GA","KY","LA","MS","NC","SC","TN","VA","WV"],"West":["AK","CA","HI","NV","OR","WA"],"Southwest":["AZ","NM","OK","TX"],"Rocky Mountain":["CO","ID","MT","UT","WY"],"New England":["CT","ME","MA","NH","RI","VT"],"Mid-Atlantic":["DE","DC","MD","NJ","NY","PA"],"Great Lakes":["IL","IN","MI","OH","WI"],"Plains":["IA","KS","MN","MO","NE","ND","SD"]}


//////////////////
// WEBPACK FOOTER
// ./static/data/region.json
// module id = 357
// module chunks = 252003105885195